import React from 'react';
import MenuLink from './MenuLink';
import MenuGroup from './MenuGroup';
import UserMenu from './UserMenu';

const MainMenu = () => {
  return (
    <nav>
      <ul>
        <MenuLink to="/home" data-icon="&#xe90b;" exact={true} title="Home">Home</MenuLink>
        <MenuLink to="/staff" data-icon="&#xe917;" title="Staff">Staff</MenuLink>
        <MenuLink to="/requirements" data-icon="&#xe914;" title="Requirements">Requirements</MenuLink>
        <MenuGroup title="Projects" data-icon="&#xe911;">
          <MenuLink to="/projects/create" title="Add a Project">Add a Project</MenuLink>
          <MenuLink to="/projects/scheduled" title="My Schedule">My Schedule</MenuLink>
          <MenuLink to="/projects/unassigned" title="Unassigned">Unassigned</MenuLink>
          <MenuLink to="/projects/assigned" title="Assigned">Assigned</MenuLink>
          <MenuLink to="/projects/completed" title="Completed">Completed</MenuLink>
        </MenuGroup>
        <MenuLink to="/reports" data-icon="&#xe913;" title="Reports">Reports</MenuLink>
        <MenuLink to="/settings" data-icon="&#xe916;" title="Settings">Settings</MenuLink>
        <UserMenu />
      </ul>
    </nav>
  )
};

export default MainMenu;



// WEBPACK FOOTER //
// ./src/components/shared/MainMenu.js